export const Confirmations = {
    // Notifications from the server on websocket
    FILES_STORED: "confirmations.files.stored",

    SET_READY_TO_REFRESH: "confirmation.set_ready_to_refresh",
    SET_EDIT_MODE: "confirmation.set_edit_mode",
    SET_TABLE_STATUS: "confirmation.set_table_status",
    SET_TABLE_CHANGES: "confirmation.set_table_changes",
    RESET_TABLE_CHANGES: "confirmation.reset_table_changes",
    SET_TABLE_ERRORS: "confirmation.set_table_errors",
    RESET_TABLE_ERRORS: "confirmation.reset_table_errors",
    SET_SELECTED_ROWS: "confirmation.set_selected_rows",
    SET_CANCEL_ERRORS: "confirmation.set_cancel_errors",
    SET_NEW_UPDATES: "confirmation.set_new_updates",
    SELECT_CONFIRMATION: "confirmation.select_confirmation",

    PREPARE_STORE: "confirmation.store.prepare",
    RESET_STORE: "confirmation.store.reset",
    UPDATE_STORE_ROW: "confirmation.store.update_row",
    DELETE_STORE_ROW: "confirmation.store.delete_row",
    ATTACH_MARKET_DATA: "confirmation.store.attach_market_data",
    APPLY_MATURITY: "confirmation.store.apply_maturity",
    SET_STORE_SETTINGS: "confirmation.store.set_settings",
    SET_STORE_ERRORS: "confirmation.store.set_errors",
    SET_CONFIRMATIONS: "confirmation.store.set_confirmations",
    SET_CONFIRMATIONS_FILTER_OPTIONS:
        "confirmation.store.set_confirmations_filter_options",
};
